import React from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";

import { routes } from "consts";
import { CategoryForm, CategoryFormValues } from "./CategoryForm/CategoryForm";
import { categoriesApi, useCategory } from "api/categories";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { getApiErrorMessage, useToaster } from "utils";
import { PaziaLoader } from "components/atoms";
import { PaziaBox, PaziaTab, PaziaTabs } from "components/atoms";
import { removeTrailingSlash } from "utils/urlUtils";
import { CategoryTerms } from "./CategoryTerms";
import { CategoryFormGroups } from "./CategoryFormGroups";

export const CategoryEditPage = (): JSX.Element | null => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const { showError, showSuccess } = useToaster();
  const { category, isLoading, invalidate } = useCategory(Number(categoryId));

  const onSubmit = async (data: CategoryFormValues) => {
    try {
      await categoriesApi.update(Number(categoryId), data);
      navigate(routes.COURSES_CATEGORIES);
      showSuccess("Kategoria została zaktualizowana");
      invalidate();
    } catch (error) {
      console.error(error);
      showError(getApiErrorMessage(error, "Wystąpił błąd podczas aktualizacji kategorii"));
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;
  if (!category) return null;

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Kategorie", path: routes.COURSES_CATEGORIES }, { title: category.name }]}
        headerText="Edytuj kategorię"
      />
      <PaziaBox>
        <CategoryTabs categoryId={categoryId!} />
        <Routes>
          <Route path={""} element={<CategoryForm category={category} onSubmit={onSubmit} />} />
          <Route path={"terms"} element={<CategoryTerms categoryId={Number(categoryId)} />} />
          <Route path={"form-groups"} element={<CategoryFormGroups categoryId={Number(categoryId)} />} />
        </Routes>
      </PaziaBox>
    </PageMain>
  );
};

const CategoryTabs = ({ categoryId }: { categoryId: string }) => {
  const checkLocationPathName = (path: string) => {
    return removeTrailingSlash(location.pathname) === removeTrailingSlash(path);
  };
  const tabs: PaziaTab[] = [
    {
      name: "Dane podstawowe",
      active: checkLocationPathName(routes.COURSES_CATEGORIES_EDIT(categoryId)),
      link: routes.COURSES_CATEGORIES_EDIT(categoryId),
    },
    {
      name: "Regulaminy",
      active: checkLocationPathName(routes.COURSES_CATEGORIES_EDIT_TERMS(categoryId)),
      link: routes.COURSES_CATEGORIES_EDIT_TERMS(categoryId),
    },
    {
      name: "Domyślne grupy",
      active: checkLocationPathName(routes.COURSES_CATEGORIES_EDIT_FORM_GROUPS(categoryId)),
      link: routes.COURSES_CATEGORIES_EDIT_FORM_GROUPS(categoryId),
    },
  ];
  return <PaziaTabs tabs={tabs} className="mb-4" />;
};
